import type { VideoItem } from '../types';
import { isProcessing } from '../utils';

export function StatusBadge({ video }: { video: VideoItem }) {
  const label = video.status.replace(/_/g, ' ');
  const statusClass = video.status === 'ready' ? 'ready' : video.status === 'failed' ? 'failed' : isProcessing(video) ? 'processing' : 'neutral';
  return <span className={`status-badge status-badge--${statusClass}`}><span className="status-badge__dot" />{label}</span>;
}
